<template>
  <div class="stack-item rating">
    <span class="rating-title" v-if="initRate">{{
      $t("SHARE_ORDER.HEADER.RATED")
    }}</span>
    <span class="rating-title" v-else>{{
      isRide
        ? $t("SHARE_ORDER.HEADER.RATING_RIDE")
        : $t("SHARE_ORDER.HEADER.RATING")
    }}</span>
    <div class="stars-wrapper">
      <Star
        v-for="n in 5"
        :key="n"
        :rated="initRate >= n"
        :value="n"
        @onClick="handleClickStar"
      />
    </div>
    <!-- <p v-if="initComment" class="comment">{{ initComment }}</p>
    <p v-if="rate > 0 && !initRate" class="rate-des">{{ $t(`SHARE_ORDER.RATING.LEVEL.${rate}`) }}</p>
    <div class="rating-box" v-if="rate > 0 && !initRate">
        <input type="text" :placeholder="$t('SHARE_ORDER.RATING.COMMENT')" v-model="comment">
        <span type="button" @click="handleSubmit">{{ $t("SHARE_ORDER.RATING.DONE") }}</span>
    </div> -->
  </div>
</template>

<script>
import Star from "./rating/Star";
export default {
  name: "Rating",
  components: {
    Star,
  },
  props: {
    initRate: Number,
    onSubmit: Function,
    initComment: String,
    isRide: { default: false, type: Boolean },
  },
  data: function() {
    return {
      rate: this.initRate || 0,
      comment: "",
    };
  },
  methods: {
    handleClickStar(value) {
      // console.log("handleClickStar", value)
      // if (!this.initRate) {
      //     if (value === this.rate) this.rate = 0
      //     else this.rate = value
      // }
      this.$emit("onClick", value);
    },
    handleSubmit() {
      if (!this.initRate && this.rate !== 0) {
        this.$emit("onSubmit", this.rate, this.comment);
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.rating {
  // display: none;
  text-align: center;
  padding: 5px 0;

  > span {
    line-height: 31px;
  }
  .stars-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    .star-wapper {
      margin: 0 5px;
    }
  }

  .rating-title {
    font-size: 12px;
  }

  .comment {
    line-height: 21px;
    font-size: 14px;
    color: #616161;
    padding-bottom: 10px;
  }

  .rate-des {
    font-size: 12px;
    color: #616161;
    padding-bottom: 10px;
    line-height: 13px;
  }

  .rating-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px 5px;

    input {
      line-height: 24px;
      border-radius: 3px;
      border: 1px solid #e2e4e6;
      width: 100%;
      height: 50px;
      padding: 0 5px;
      font-size: 14px;
    }

    span {
      width: 64px;
      color: #fff;
      background-color: #f37336;
      border-color: #f37336;
      border-radius: 3px;
      width: 100%;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      margin-top: 10px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .rating {
    display: initial;
  }
}
</style>
